<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="search_box">
        <div class="feedback_get_type">
          <el-form class="searchForm">
            <el-form-item label="反饋類型:" class="searchItem">
              <el-select v-model="feedbackType" placeholder="请选择">
                <el-option label="全部" value="0"></el-option>
                <el-option label="程序bug" value="1"></el-option>
                <el-option label="產品建議" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div style="display:flex;">
          <div class="btn" @click="search()">查詢</div>
          <div class="btn borderBtn" @click="reset()">重置</div>
        </div>
      </div>

      <div class="tableWrap">
        <el-table
          height="660px"
          stripe
          :data="feedbackList"
          style="width:100%;"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in feedbackTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row, scope.$index)"
                >操作</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <div class="feedback_detail" v-if="showFeedbackDetail">
      <div class="feedback_detail_bg" @click="closeDetail"></div>
      <div class="feedback_detail_box">
        <div class="feedback_detail_title">反饋詳情</div>
        <div class="feedback_detail_list">
          <div class="list_name">反饋類型：</div>
          <div class="list_content">{{ lookDetail.type }}</div>
        </div>
        <div class="feedback_detail_list">
          <div class="list_name">反饋內容：</div>
          <div class="list_content">{{ lookDetail.reason }}</div>
        </div>
        <div class="feedback_detail_list" v-if="!!lookDetail.picture.length">
          <div class="list_name">反饋圖片：</div>
          <div class="list_content">
            <div class="feedback_picture_list">
              <div
                class="feedback_picture"
                v-for="(url, index) of lookDetail.picture"
                :key="index"
                :class="'feedback_picture' + index"
                v-viewer="{ movable: false }"
              >
                <img :src="url" />
                <div @click="lookBigImg(index)">查看大圖</div>
              </div>
            </div>
          </div>
        </div>
        <div class="feedback_detail_list">
          <div class="list_name">備註：</div>
          <div class="list_content">
            <textarea v-model="remarks" placeholder="請輸入備註"></textarea>
          </div>
        </div>
        <div class="btn_list">
          <div class="btn borderBtn" @click="closeDetail">取消</div>
          <div class="btn" @click="saveFn">保存</div>
        </div>
        <div class="close_btn">
          <button
            type="button"
            aria-label="Close"
            class="el-message-box__headerbtn"
            @click="closeDetail"
          >
            <i
              class="el-message-box__close el-icon-close"
              style="font-size: 0.2rem"
            ></i>
          </button>
        </div>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
export default {
  data() {
    return {
      navBlock: "會員",
      navtitle: "意見反饋",
      editNotice: false,
      feedbackList: [],
      feedbackTable: [
        {
          prop: "userId",
          label: "會員編號",
          width: ""
        },
        {
          prop: "userName",
          label: "會員帳號",
          width: ""
        },
        {
          prop: "iphone",
          label: "聯繫電話",
          width: ""
        },
        {
          prop: "reason",
          label: "意見反饋",
          width: "250"
        },
        {
          prop: "type",
          label: "反饋類型",
          width: ""
        },
        {
          prop: "creatTime",
          label: "反饋時間",
          width: ""
        },
        {
          prop: "remarks",
          label: "備註",
          width: ""
        }
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
      lookDetail: {},
      showFeedbackDetail: false,
      detailIndex: 0,
      remarks: "",
      feedbackType: "0"
    };
  },
  created() {
    this.getfeedbackList();
  },
  activated() {
    if (this.currentPage === 1) {
      this.getfeedbackList();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取意见反馈列表信息
    getfeedbackList() {
      let _this = this;
      let arr = ["", "程序BUG", "產品建議"];
      let url = `/request/version/getOpinionList?pageNo=${_this.currentPage}&pageSize=10`;
      if (this.feedbackType !== "0") {
        url = `${url}&type=${this.feedbackType}`;
      }
      this.$get(url, {}, this.$GLOBAL.jsonConfig).then(res => {
        if (res.code === "00000") {
          console.log(res.data);
          res.data.list.forEach(v => {
            v.creatTime = _this.$getTime(v.createTime);
            v.remarks = v.remarks || "-";
            v.type = !v.type ? "-" : arr[v.type];
            v.iphone = v.iphone || "-";
          });
          console.log(res.data.list);
          _this.feedbackList = res.data.list;
          _this.total = res.data.allRow;
          _this.lookDetail = res.data.list[0];
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getfeedbackList();
    },
    edit(val, index) {
      this.lookDetail = val;
      this.detailIndex = index;
      this.showFeedbackDetail = true;
      this.remarks = val.remarks === "-" ? "" : val.remarks;
    },
    lookBigImg(index) {
      let className = ".feedback_picture" + index;
      const frontViewer = this.$el.querySelector(className).$viewer;
      frontViewer.show();
    },
    saveFn() {
      let type = true;
      if (this.lookDetail.remarks === "-" && !this.remarks) {
        type = false;
      }
      if (this.remarks === this.lookDetail.remarks) {
        type = false;
      }
      if (!type) {
        this.closeDetail();
        return false;
      }
      let param = {
        id: this.lookDetail.id,
        remarks: this.remarks
      };
      this.$post(
        `/request/version/updateOpinion`,
        param,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code === "00000") {
          this.feedbackList[this.detailIndex].remarks = this.remarks;
          this.closeDetail();
        }
      });
    },
    closeDetail() {
      this.showFeedbackDetail = false;
    },
    search() {
      this.getfeedbackList();
    },
    reset() {
      this.feedbackType = "0";
      this.getfeedbackList();
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style scoped lang="less">
.feedback_detail {
  position: fixed;
  z-index: 1000;
  .feedback_detail_bg {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #000;
    opacity: 0.5;
  }
  .feedback_detail_box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 5.6rem;
    max-height: 5.6rem;
    padding-bottom: 30px;
    background-color: #fff;
    border-radius: 6px;
    color: #606266;
    overflow-y: auto;
    .feedback_detail_title {
      margin-bottom: 20px;
      padding: 15px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 16%);
      font-size: 16px;
      color: #303133;
      line-height: 1;
      font-weight: bold;
    }
    .feedback_detail_list {
      padding: 30px 40px;
      display: flex;
      align-items: flex-start;
      .list_name {
        margin-right: 40px;
        width: 80px;
        flex-shrink: 0;
        text-align: right;
      }
      .list_content {
        text-align: left;
        word-break: break-all;
      }
      .feedback_picture {
        position: relative;
        margin-bottom: 48px;
        width: 286px;
        height: 178px;
        div {
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 13px;
          color: #6841dc;
          cursor: pointer;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      textarea {
        width: 298px;
        height: 52px;
        padding: 14px 18px;
        border-radius: 6px;
        background-color: #e8e6f0;
        border: none;
        resize: none;
      }
    }
    .btn_list {
      display: flex;
      align-items: center;
      justify-content: center;
      .borderBtn {
        margin-right: 50px;
      }
    }
    .cancel_btn {
    }
    .save_btn {
      margin: auto;
      width: 80px;
      height: 25px;
      line-height: 25px;
      border: 1px solid #ddd;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }
    .close_btn {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
    }
  }
}
.feedback_get_type {
  text-align: left;
}
.search_box {
  display: flex;
  justify-content: space-between;
  .btn {
    margin-top: 40px;
  }
  .borderBtn {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/feedback.vue